export default {
  brandColor1: '#57267C',
  complimentaryColor1: '#fff',
  brandColor2: '#F49525',
  complimentaryColor2: '#fff',
};
